import { baseApiSlice } from '../../commons/base-api.config';
import {
    API_APPRENTICE_GENERATE_AD,
    API_APPRENTICE_GENERATE_CAMPAIGN,
    API_APPRENTICE_REMOVE_BACKGROUND,
} from '../../constants/api';
import { HTTP_METHODS } from '../../constants/http';
import { IGenerateCampaignRequestPayload } from '../../pages/Apprentice/apprentice.interface';

export const apprenticeApiSlice = baseApiSlice.injectEndpoints({
    endpoints(builder) {
        return {
            chatApprentice: builder.mutation<any, FormData>({
                query: (data) => {
                    return {
                        url: API_APPRENTICE_GENERATE_AD,
                        method: HTTP_METHODS.POST,
                        body: data,
                    };
                },
                transformResponse: (res: any) => res.data,
                transformErrorResponse: (response: { status: string | number }) => response.status,
            }),
            generateCampaign: builder.mutation<any, IGenerateCampaignRequestPayload>({
                query: (data) => {
                    return {
                        url: API_APPRENTICE_GENERATE_CAMPAIGN,
                        method: HTTP_METHODS.POST,
                        body: data,
                    };
                },
                transformResponse: (res: any) => res.data,
                transformErrorResponse: (response: { status: string | number }) => response.status,
            }),
            backgroundRemoval: builder.mutation<any, FormData>({
                query: (data) => {
                    return {
                        url: API_APPRENTICE_REMOVE_BACKGROUND,
                        method: HTTP_METHODS.POST,
                        body: data,
                    };
                },
                transformResponse: (res: any) => res.data,
                transformErrorResponse: (response: any) => response.data,
            }),
        };
    },
});

export const {
    useGenerateCampaignMutation,
    useChatApprenticeMutation,
    useBackgroundRemovalMutation,
} = apprenticeApiSlice;
